export const deferralPaymentLocalization = {
  noInvoiceLabel: {
    nb: 'Du har ingen aktuelle fakturaer. Dette kan være fordi lånet tidligere har fått innvilget betalingsutsettelse. For å søke om ytterligere betalingsutsettelse kan du ta kontakt med din rådgiver eller {0}.',
    nn: 'Du har ingen aktuelle fakturaer. Dette kan vere fordi lånet tidlegare har fått innvilga betalingsutsetjing. For å søkje om ytterlegare betalingsutsetjing kan du ta kontakt med rådgjevaren din eller {0}.',
    en: 'You have no relevant invoices. This may be because the loan has previously been granted a deferral of payment. To apply for further deferral of payment, you can contact your advisor or {0}.',
  },

  noLoanLabel: {
    en: 'There is no loan that is relevant!',
    nb: 'Det er ingen lån som er aktuell!',
    nn: 'Det er ingen lån som er aktuell!',
  },
} as const;
